import { useThree } from "@react-three/fiber";
import { useProductModelStore } from "../../store/productModelStore"
import { findFromProducts } from "../../utils/productModelUtils"
import { ElementTypeEnum } from "../../elementTypeMappings";
import { buildApartmentViewModels } from "../../utils/apartmentUtils";
import ApartmentNameComponent from "./ApartmentNameComponent";

const ApartmentNamesComponent = () => {

    const { scene } = useThree();

    const {products, apartments}= useProductModelStore();
    
    const allSpaces = findFromProducts(products, [ElementTypeEnum.Space]);

    const apartmentVms = buildApartmentViewModels(apartments, allSpaces);

    return (
        <>
            {apartmentVms.length > 1 && apartmentVms.map((vm, idx) => (
                <ApartmentNameComponent key={idx} apartmentViewModel={vm} />
            ))}
        </>
    );

}

export default ApartmentNamesComponent;